import { BenefitDTO, MobilityBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class MobilityBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsMobility = activeBenefit.details as MobilityBenefitDetailsDTO;

    // Calculate benefitProgress safely to avoid division by zero
    let benefitProgress = 0;
    if (detailsMobility.maxRefund > 0) {
      benefitProgress = (detailsMobility.refund / detailsMobility.maxRefund) * 100;
      // Clamp the result to 0-100 range
      benefitProgress = Math.max(0, Math.min(100, benefitProgress));
    }

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/mobility',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description`,
      descriptionValues: { refund: detailsMobility.refund, maxRefund: detailsMobility.maxRefund },
      benefitProgress,
    };
  }
}
